import StudentVocabularyAnswerApi from './StudentVocabularyAnswerApi';
export default StudentVocabularyAnswerApi;
